export enum EnumSincronizacaoGeralStatus {
    Erro = 0,
    EmAndamento = 1,
    Finalizado = 2
}